import { createContext } from 'react'

const ApplicantDataFormContext = createContext({})

export default ApplicantDataFormContext
